import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { NavLink, Switch, Route } from 'react-router-dom';
import { GoogleLogin } from 'react-google-login';
import ReCAPTCHA from 'react-google-recaptcha';
import './App.css';
import LoggedOut from './loggedout';
import Restore from './restore';
import {get_messages, post} from './procedures';
import {googleSiteKey} from './procedures';
import {googleSignInKey} from './procedures';
import RestoreConfirmation from './restore_confirmation';
import Register from './register_form';
import RegisterComplete from './register_complete';
import OneTimeLogin from './one_time_login';
import RegisterConfirmed from './register_confirmed';
import nl2br from 'react-newline-to-break';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://www.alaber.ru/">
        www.alaber.ru
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        height: 43,
        //
    },
    submitgrid: {
        margin: theme.spacing(1, 0, 1),
    },
    linkCenter: {
        textAlign: 'center',
    },
    error: {
        textAlign: 'center',
        color: 'red',
    },
}));

/*const LoginButton = withStyles({
    root: {
        top: -4,
        //background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        //borderRadius: 3,
        //border: 0,
        //color: 'white',
        height: 50,
        //padding: '0 30px',
        //boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    },
    //label: {
    //    textTransform: 'capitalize',
    //},
})(Button);*/

class LoginForm extends React.Component  {
    constructor(props) {
        super(props);

        this.state = {errorStr: ''};

        this.state = {httpd_username: ''};
        this.state = {httpd_password: ''};
        this.state = {recaptchaToken: ''};

        this.emailChange = this.emailChange.bind(this);
        this.passChange = this.passChange.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.captchaCallback = this.captchaCallback.bind(this);
        this.responseGoogle = this.responseGoogle.bind(this);
        this.setErrorStr = this.setErrorStr.bind(this);

        this.state = {recaptchaRef: React.createRef()};

        get_messages('register_form_error', this.setErrorStr);
    }

    setErrorStr(add_errorStr) {
        let errorStr = this.state.errorStr;
        if (errorStr == undefined) { errorStr = '' }
        if (errorStr.length != 0) {
            //errorStr = errorStr.concat('\n');
            errorStr = '';
        }

        errorStr = errorStr.concat( add_errorStr );

        this.setState({errorStr: errorStr});
    }

    emailChange(event) {
        this.setState({httpd_username: event.target.value})
    }

    passChange(event) {
        this.setState({httpd_password: event.target.value})
    }

    captchaCallback(recaptchaToken) {
        this.setState({recaptchaToken: recaptchaToken})
        // Here you will get the final recaptchaToken!!!
        console.log(recaptchaToken, "<= your recaptcha token")
    }

    handleLogin() {
        console.log("handleLogin");
        //this.state.recaptchaRef.current.execute();

        const recaptchaValue = this.state.recaptchaRef.current.getValue();
        //this.state = {recaptchaRef: this.recaptchaRef.current.getValue()}

        //console.log( this.state.httpd_username );
        //console.log( this.state.httpd_password );
        //console.log( recaptchaValue );

        var obj_tosend={};
        obj_tosend.action = 'logIn';
        obj_tosend.g_recaptcha_response = recaptchaValue;
        obj_tosend.httpd_username = this.state.httpd_username;
        obj_tosend.httpd_password = this.state.httpd_password;

        post('./tokensignin.php', obj_tosend);
        //post('http://192.168.1.43/login_to_console/tokensignin.php', obj_tosend);
        //post('./tokensignin.php', obj_tosend);

    }

    handleSubmit(event) {
        this.state.recaptchaRef.current.execute();
    }

    responseGoogle (response) {
        //console.log(response);
        var obj_tosend={};
        obj_tosend.action = 'logIn';
        obj_tosend.idtoken = response.tokenId;

        //post('https://www.alaber.ru/login_to_console/tokensignin.php', obj_tosend);
        post('./tokensignin.php', obj_tosend);
    }

    render() {

        return (
            <Container component="main" maxWidth="xs">
                <div className={this.props.classes.paper}>
                    <Avatar className={this.props.classes.avatar}>
                        <LockOutlinedIcon/>
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Авторизируйтесь
                    </Typography>
                    <form className={this.props.classes.form} noValidate>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            onChange={this.emailChange}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Пароль"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            onChange={this.passChange}
                        />
                        <div className={this.props.classes.error}>{ nl2br(this.state.errorStr) }</div>
                        <Grid container spacing='1' alignItems="center" className={this.props.classes.submitgrid}>
                            <Grid item xs>
                                <Button
                                    fullWidth
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    className={this.props.classes.submit}
                                    onClick={this.handleSubmit}
                                >
                                    Войти
                                </Button>
                            </Grid>
                            <Grid item xs>
                                <GoogleLogin className="btnGoogle"
                                    clientId={googleSignInKey}
                                    onSuccess={this.responseGoogle}
                                    cookiePolicy='single_host_origin'
                                    theme='dark'
                                    buttonText='Google'
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs>
                                <Link href="./restore" variant="body2">
                                    Забыли пароль?
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link href="./register" variant="body2">
                                    {"Зарегистрироваться"}
                                </Link>
                            </Grid>
                        </Grid>
                        <ReCAPTCHA ref={this.state.recaptchaRef}
                                   sitekey={googleSiteKey}
                                   size="invisible"
                                   onChange = {this.handleLogin}
                        />
                    </form>
                </div>
            </Container>
        )

    }
}

class Home extends React.Component {
  render () {
      return (
          <div className='home'>
              <LoginForm classes={this.props.classes}/>
          </div>
      )
  }
}

function About () {
  return (
  <div className='About'>
    <h1>About Me</h1>
    <p>Ipsum dolor dolorem consectetur est velit fugiat. Dolorem provident corporis fuga saepe distinctio ipsam? Et quos
      harum excepturi dolorum molestias?</p>
    <p>Ipsum dolor dolorem consectetur est velit fugiat. Dolorem provident corporis fuga saepe distinctio ipsam? Et quos
      harum excepturi dolorum molestias?</p>
  </div>
  )
}

function Contact () {
  return (
      <div className='Contact'>
         <h1>Contact Me</h1>
         <p>You can reach me via email: <strong>hello@example.com</strong></p>
      </div>
  )
}

class Main extends React.Component {
    render() {
        return (
            <Switch>
                <Route exact path={`${process.env.PUBLIC_URL}/`} render={(props) => <Home classes={this.props.classes}/>}></Route>
                <Route exact path={`${process.env.PUBLIC_URL}/about`} component={About}></Route>
                <Route exact path={`${process.env.PUBLIC_URL}/contact`} component={Contact}></Route>
                <Route exact path={`${process.env.PUBLIC_URL}/loggedout`} render={()=><LoggedOut classes={this.props.classes}/>}></Route>
                <Route exact path={`${process.env.PUBLIC_URL}/restore`} render={(props) => <Restore classes={this.props.classes}/>}></Route>
                <Route exact path={`${process.env.PUBLIC_URL}/restore_confirmation`} render={(props) => <RestoreConfirmation classes={this.props.classes}/>}></Route>
                <Route exact path={`${process.env.PUBLIC_URL}/register`} render={(props) => <Register classes={this.props.classes}/>}></Route>
                <Route exact path={`${process.env.PUBLIC_URL}/register_complete`} render={(props) => <RegisterComplete classes={this.props.classes}/>}></Route>
                <Route exact path={`${process.env.PUBLIC_URL}/register_confirmed`} render={(props) => <RegisterConfirmed classes={this.props.classes}/>}></Route>
                <Route exact path={`${process.env.PUBLIC_URL}/one_time_login/:restoreid`} render={(props) => <OneTimeLogin classes={this.props.classes} pathname={props.location.pathname} />}></Route>
            </Switch>
        )
        //mathparams={this.props.match.params}
    }
}

function Navigation () {
    return (
        <nav>
          <ul>
            <li><NavLink exact activeClassName="current" to={`${process.env.PUBLIC_URL}/`}>Вход</NavLink></li>
            <li><NavLink exact activeClassName="current" to={`${process.env.PUBLIC_URL}/about`}>О нас</NavLink></li>
            <li><NavLink exact activeClassName="current" to={`${process.env.PUBLIC_URL}/contact`}>Контакты</NavLink></li>
            <li><NavLink exact activeClassName="current" to={`${process.env.PUBLIC_URL}/loggedout`}>loggedout</NavLink></li>
            <li><NavLink exact activeClassName="current" to={`${process.env.PUBLIC_URL}/restore`}>Restore</NavLink></li>
            <li><NavLink exact activeClassName="current" to={`${process.env.PUBLIC_URL}/restore_confirmation`}>Restore Confirmation</NavLink></li>
            <li><NavLink exact activeClassName="current" to={`${process.env.PUBLIC_URL}/register`}>Register</NavLink></li>
            <li><NavLink exact activeClassName="current" to={`${process.env.PUBLIC_URL}/register_complete`}>Register Complete</NavLink></li>
            <li><NavLink exact activeClassName="current" to={`${process.env.PUBLIC_URL}/register_confirmed`}>Register Confirmed</NavLink></li>
            <li><NavLink exact activeClassName="current" to={`${process.env.PUBLIC_URL}/one_time_login/:restoreid`}>OneTime Login</NavLink></li>
          </ul>
        </nav>
    )
}

export default function Login_to_console() {

    const classes = useStyles();

    return (
        <div className='app'>
          <CssBaseline />
          <Grid container spacing={1} alignItems="center">
              <Grid item xs>
                  <Box width="131px" height="98px">
                      <img src="../standard_trade_co/black-bull-small.png" className="img-fluid" alt=""/>
                  </Box>
              </Grid>
              <Grid item xs>
                  <Typography component="h1" variant="h5" align="center">Alaber</Typography>
              </Grid>
              <Grid item xs>
                  <Typography component="h1" variant="h5" align="right">Личный кабинет</Typography>
              </Grid>
          </Grid>
          <Main classes={classes}/>
          <Box mt={8}>
            <Copyright />
          </Box>
        </div>
    );
}
